import { parseAbi } from 'viem';

// PancakeSwap Contract Addresses on BSC
export const PANCAKE_ROUTER_V2 = '0x10ED43C718714eb63d5aA57B78B54704E256024E';
export const PANCAKE_ROUTER_V3 = '0x1b81D678ffb9C0263b24A97847620C99d213eB14';
export const PANCAKE_SMART_ROUTER = '0x13f4EA83D0bd40E75C8222255bc855a974568Dd4';
export const PANCAKE_UNIVERSAL_ROUTER = '0xd9C500DfF816a1Da21A48A732d3498Bf09dc9AEB'; // Infinity Universal Router (Latest)
export const PANCAKE_FACTORY_V2 = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73';
export const PANCAKE_FACTORY_V3 = '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865';

// Token Addresses
export const WBNB_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c';
export const LRST_ADDRESS = '0x6421355286Ecb21Ad502582Cd0B0DA16971D5F45';
export const USDT_ADDRESS = '0x55d398326f99059fF775485246999027B3197955';
export const USDC_ADDRESS = '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d';
export const BTCB_ADDRESS = '0x7130d2a12b9bcbaacb0d2e4f0bcd0e3e2f7f0f7f';
export const ETH_ADDRESS = '0x2170ed0880ac9a755fd29b2688956bd959f933f8';

// ABIs - Wrapped with parseAbi for wagmi v2+ compatibility
export const ERC20_ABI = parseAbi([
  'function symbol() view returns (string)',
  'function name() view returns (string)',
  'function decimals() view returns (uint8)',
  'function balanceOf(address) view returns (uint256)',
  'function allowance(address,address) view returns (uint256)',
  'function approve(address,uint256) returns (bool)'
]);

export const PANCAKE_ROUTER_V2_ABI = parseAbi([
  'function getAmountsOut(uint amountIn, address[] calldata path) view returns (uint[] memory amounts)',
  'function swapExactETHForTokensSupportingFeeOnTransferTokens(uint amountOutMin, address[] calldata path, address to, uint deadline) payable',
  'function swapExactTokensForETHSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline)',
  'function swapExactTokensForTokensSupportingFeeOnTransferTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline)'
]);

export const PANCAKE_ROUTER_V3_ABI = parseAbi([
  'function exactInputSingle((address tokenIn, address tokenOut, uint24 fee, address recipient, uint256 amountIn, uint256 amountOutMinimum, uint160 sqrtPriceLimitX96)) payable returns (uint256 amountOut)'
]);

export const PANCAKE_SMART_ROUTER_ABI = parseAbi([
  'function swapExactTokensForTokens(uint256 amountIn, uint256 amountOutMin, address[] calldata path, address to) returns (uint256 amountOut)'
]);

// PancakeSwap Universal Router ABI (Simplified for swap execution)
export const PANCAKE_UNIVERSAL_ROUTER_ABI = parseAbi([
  'function execute(bytes calldata commands, bytes[] calldata inputs, uint256 deadline) payable',
  'function execute(bytes calldata commands, bytes[] calldata inputs) payable'
]);
